import React from 'react';

export default function DatenschutzCheckbox({ checked, onChange, error }) {
  return (
    <div style={{ marginTop: '1.25rem' }}>
      <div className="datenschutz-row">
        <input
          type="checkbox"
          id="datenschutz"
          name="datenschutz_akzeptiert"
          checked={checked}
          onChange={onChange}
        />
        <label htmlFor="datenschutz" className="datenschutz-text">
          Ich habe die{' '}
          <a
            href="https://sv-grevenbroich.de/datenschutzerklaerung"
            target="_blank"
            rel="noopener noreferrer"
          >
            Datenschutzerklärung
          </a>{' '}
          gelesen und akzeptiere sie. *
        </label>
      </div>
      {error && <span className="form-error" style={{ marginTop: '0.25rem', display: 'block' }}>{error}</span>}
    </div>
  );
}
